import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './style.module.scss';
import FilterDropdown, { DARK_THEME, FilterDropdownTheme } from 'components/search-bar/advanced-search/filter-dropdown';
import FilterDropdownRange from 'components/search-bar/advanced-search/filter-dropdown/number-range';
import { searchFilterIds } from 'constants/test-constants';
import SqftIcon from 'components/icon/filters/sqft-icon';
import PriceIcon from 'components/icon/filters/price-icon';
import formatPriceRange, { formatSqftRange } from 'utils/format-price';
import { Namespaces } from 'types/locales';

export interface RangeFilterDropdownProps {
  min: number | null;
  max: number | null;
  onValueChange: (min: number | null, max: number | null) => void;
  theme?: FilterDropdownTheme;
  rangeType: 'sqft' | 'price';
  rental?: boolean;
}

const RangeFilterDropdown = ({ min, max, onValueChange, theme = DARK_THEME, rangeType, rental = false }: RangeFilterDropdownProps) => {
  const { t, i18n } = useTranslation(Namespaces.SEARCH);
  
  const parseFilterLabel = useMemo(() => {
    if (rangeType === 'sqft') {
      return formatSqftRange(min, max, t);
    } else if (rangeType === 'price') {
      return formatPriceRange(min, max, t, i18n.language || 'en-CA');
    }
  }, [min, max, t, i18n.language, rangeType]);

  return (
    <FilterDropdown
      theme={theme}
      label={parseFilterLabel}
      testId={rangeType === 'sqft' ? searchFilterIds.sqftDropdownMap : searchFilterIds.priceRangeDropdownMap}
      contentClassName={styles['custom-panel-style']}
      icon={rangeType === 'sqft' ? <SqftIcon /> : <PriceIcon />}
      isDefaultValue={min === null && max === null}
    >
      <FilterDropdownRange
        min={min}
        max={max}
        isRental={rental}
        onValueChange={onValueChange}
        isCurrency={rangeType === 'price'}
      />
    </FilterDropdown>
  );
};

export default RangeFilterDropdown;
